import jsPDF from "jspdf";
import "jspdf-autotable";

const downloadPDF = ({
  title,
  docName,
  startDate,
  endDate,
  status,
  outletName,
  columns,
  rows,
  totalOrder,
  totalSale,
  totalOrderAmout,
  totalTaxAmount,
  totalReciveAmout,
  customerName,
  // Credit Report specific parameters
  totalOutstanding,
  totalInvoiced,
  totalCreditLimit,
  totalCustomers,
  currentAmount,
  thirtyDaysAmount,
  sixtyDaysAmount,
  over90DaysAmount,
}) => {
  const doc = new jsPDF();

  // Add heading
  doc.setFontSize(16);
  doc.text(`${title || ""}`, 14, 18);

  doc.setFontSize(9);
  if (title === "Order Report") {
    doc.text(`Start Date: ${startDate || ""}`, 14, 28);
    doc.text(`End Date: ${endDate || ""}`, 80, 28);
    doc.text(`Outlet Name: ${outletName || ""}`, 14, 34);
    doc.text(`Status: ${status || "All"}`, 180, 28);
    doc.text(`Total Orders: ${totalOrder || "0"}`, 80, 34);
    doc.text(`Total Orders Amount: ${totalOrderAmout || "0"}`, 150, 34);
    doc.autoTable({
      startY: 42,
      head: [columns],
      body: rows,
    });
  } else if (title === "Sales Report") {
    doc.text(`Start Date: ${startDate || ""}`, 14, 28);
    doc.text(`End Date: ${endDate || ""}`, 80, 28);
    doc.text(`Outlet Name: ${outletName || ""}`, 150, 28);
    doc.text(`Total Orders: ${totalOrder || "0"}`, 14, 34);
    doc.text(`Total Sales: ${totalSale || "0.00"}`, 80, 34);
    doc.text(`Total Tax Amount: ${totalTaxAmount || "0.00"}`, 150, 34);
    doc.autoTable({
      startY: 42,
      head: [columns],
      body: rows,
    });
  } else if (title === "Product/Service Report") {
    doc.text(`Start Date: ${startDate || ""}`, 14, 28);
    doc.text(`End Date: ${endDate || ""}`, 80, 28);
    doc.text(`Outlet Name: ${outletName || ""}`, 150, 28);
    doc.autoTable({
      startY: 42,
      head: [columns],
      body: rows,
    });
  } else if (title === "Customer Order Report") {
    doc.text(`Start Date: ${startDate || ""}`, 14, 28);
    doc.text(`End Date: ${endDate || ""}`, 80, 28);
    doc.text(`Outlet Name: ${outletName || ""}`, 150, 28);
    doc.text(`Total Orders: ${totalOrder || "0"}`, 14, 34);
    doc.text(`Order Amount: ${totalOrderAmout || "0.00"}`, 80, 34);
    doc.text(`Received Amount:: ${totalReciveAmout || "0.00"}`, 150, 34);
    doc.autoTable({
      startY: 42,
      head: [columns],
      body: rows,
    });
  } else if (title === "Order Queue Report") {
    doc.text(`Start Date: ${startDate || ""}`, 14, 28);
    doc.text(`End Date: ${endDate || ""}`, 80, 28);
    doc.text(`Outlet Name: ${outletName || ""}`, 150, 28);
    doc.autoTable({
      startY: 35,
      head: [columns],
      body: rows,
    });
  } else if (title === "Inventory Report") {
    doc.text(`Start Date: ${startDate || ""}`, 14, 28);
    doc.text(`End Date: ${endDate || ""}`, 80, 28);
    doc.autoTable({
      startY: 35,
      head: [columns],
      body: rows,
    });
  } else if (title === "Credit Report") {
    doc.text(`Start Date: ${startDate || ""}`, 14, 28);
    doc.text(`End Date: ${endDate || ""}`, 100, 28);
    doc.text(`Total Customers: ${totalCustomers || "0"}`, 14, 34);
    doc.text(`Total Credit Limit: R ${totalCreditLimit || "0.00"}`, 100, 34);
    doc.text(`Total Outstanding: R ${totalOutstanding || "0.00"}`, 14, 40);
    doc.text(`Total Invoiced: R ${totalInvoiced || "0.00"}`, 100, 40);

    // Aging Summary
    doc.setFontSize(8);
    doc.text("Aging Summary:", 14, 50);
    doc.text(`Current: R ${currentAmount || "0.00"}`, 14, 56);
    doc.text(`30 Days: R ${thirtyDaysAmount || "0.00"}`, 70, 56);
    doc.text(`60 Days: R ${sixtyDaysAmount || "0.00"}`, 125, 56);
    doc.text(`90+ Days: R ${over90DaysAmount || "0.00"}`, 170, 56);

    doc.autoTable({
      startY: 65,
      head: [columns],
      body: rows,
      styles: {
        fontSize: 8,
        cellPadding: 3,
        overflow: "linebreak",
        halign: "left",
      },
      headStyles: {
        fillColor: [75, 75, 75],
        textColor: 255,
        fontSize: 8,
        fontStyle: "bold",
        cellPadding: 3,
      },
      columnStyles: {
        0: { cellWidth: 20 }, // Customer Name
        1: { cellWidth: 23 }, // Invoice Number
        2: { cellWidth: 18 }, // Date
        3: { cellWidth: 18 }, // Due Date
        4: { cellWidth: 16 }, // Amount
        5: { cellWidth: 22 }, // Outstanding
        6: { cellWidth: 18 }, // Payments
        7: { cellWidth: 18 }, // Current
        8: { cellWidth: 18 }, // 30 Days
        9: { cellWidth: 18 }, // 60 Days
        10: { cellWidth: 18 }, // 90+ Days
      },
      margin: { top: 65, left: 2, right: 2 },
      tableWidth: "auto",
      theme: "grid",
    });
  } else if (title === "Daily Occupancy Report") {
    doc.text(`Start Date: ${startDate || ""}`, 14, 28);
    doc.text(`End Date: ${endDate || ""}`, 80, 28);
    doc.autoTable({
      startY: 35,
      head: [columns],
      body: rows,
    });
  } else {
    // Fallback for any other reports
    doc.text(`Start Date: ${startDate || ""}`, 14, 28);
    doc.text(`End Date: ${endDate || ""}`, 80, 28);
    doc.autoTable({
      startY: 35,
      head: [columns],
      body: rows,
    });
  }

  // Save the PDF
  doc.save(`${docName || "document"}.pdf`);
};

export default downloadPDF;
